import React from 'react';
import { connect } from 'react-redux';
import { Widget } from '@spins/react-ui-library';
import * as selectors from 'containers/Campaigns/CreateEdit/store/selectors';
import * as actions from 'containers/Campaigns/CreateEdit/store/actions';
import { DetailsType } from 'containers/Campaigns/CreateEdit/store/reducer';
import CreateEditCampaignDetailsForm from 'components/Campaigns/CreateEdit/DetailsForm';

interface Props {
  details: DetailsType;
  savingError?: string;
  onNameBlur(name: string, storeGroupName: string, itemGroupName: string): void;
  onValueChange(value: string, attribute: string): void;
}

const CreateEditCampaignDetails: React.FC<Props> = ({
  details,
  savingError,
  onNameBlur,
  onValueChange,
}) => {
  return (
    <div className="create-campaign-details">
      <Widget>
        {{
          header: {
            title: 'Campaign Details',
          },
          body: {
            style: { padding: '0px' },
            content: (
              <CreateEditCampaignDetailsForm
                details={details}
                error={savingError}
                onNameBlur={onNameBlur}
                onValueChange={onValueChange}
              />
            ),
          },
        }}
      </Widget>
    </div>
  );
};

const mapStateToProps = (state) => ({
  details: selectors.detailsSelector(state),
  savingError: selectors.savingErrorSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onNameBlur(name: string, storeGroupName: string, itemGroupName: string): void {
    if (storeGroupName === '') {
      dispatch(actions.changeDetailsValue(`${name} SG`, 'storeGroupName'));
    }
    if (itemGroupName === '') {
      dispatch(actions.changeDetailsValue(`${name} IG`, 'itemGroupName'));
    }
  },
  onValueChange: (value: string, attribute: string) => {
    dispatch(actions.changeDetailsValue(value, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateEditCampaignDetails);
